import labels from "../../../constants/displayFields";

const section = "destination";

const DESTINATION_STRING_FIELDS = [
  ["new_building", "newBuilding"],
  ["new_room", "newRoom"],
  ["new_floor", "newFloor"],
  ["destination_employee_name", "destinationEmployeeName"],
  ["destination_comments", "destinationComments"],
  ["destination_number", "destinationNumber"],
  ["install_responsibility", "installResponsibility"],
];

export default function useEnabledDestination({ display, disabledForm, type, asset }) {
  const fields = [
    ...DESTINATION_STRING_FIELDS.map(([id, name]) => ({
      id,
      enabled: display[id],
      type: "input",
      section,
      gridProps: { sm: 12 },
      params: {
        type: "autoExpand",
        name,
        label: labels[id],
        disabled: disabledForm,
      },
    })),
    {
      id: "destination_room_number",
      enabled: display.destination_room_number,
      type: "destination_room_number",
      section,
      gridProps: { sm: 12 },
      params: {
        captureType: type,
        asset,
        disabled: disabledForm,
      },
    },
    {
      id: "destination_quantity",
      enabled: display.destination_quantity,
      type: "input",
      section,
      gridProps: { sm: 12 },
      params: {
        type: "number",
        name: "destinationQuantity",
        label: labels.destination_quantity,
        disabled: disabledForm,
        showNAButton: false,
      },
    },
  ].filter(field => field.enabled);

  return fields;
}
